
const api = process.env.NODE_ENV != 'production' ? '/api/newymapi' : '/api'
// public

export const getCountryIdAndName = `/waiterapi/Info/getCountryIdAndName`;
export const getCountryNumIdAndName= `/waiterapi/api/Info/getCountryIdAndName`;
export const getCampaignList = `${api}/Yeahagency/getCampaignList`;
export const getConfigList='/waiterapi/mgr/config/get'
export const getCategory='/waiterapi/Info/crmTradeAndDemandDict'
export const checkPubSetting=`/waiterapi/Yeahagency/user/checkPubSetting`
export const getConfigListnew = `/waiterapi/mgr/config/get`

// home

export const getNotice = `${api}/Yeahagency/getNotice`
export const getExhibitionWall = `${api}/Yeahagency/getExhibitionWall`
export const getMediaResource = `${api}/Yeahagency/getMediaResource`
export const getYeahagencyList = `/waiterapi/Yeahagency/getYeahagencyList`
export const getAllMenuRoles = `/waiterapi/Yeahagency/role/findSelfMenu`

// CPS模块_dashboard 
export const checkModSetting=`/waiterapi/Yeahagency/user/checkModSetting`


export const getCpsAffiliateInfoList = `${api}/Yeahagency/getCpsAffiliateInfoList`;
export const checkAff = `${api}/Yeahagency/checkAff`;
export const setCpsAffInfo = `${api}/Yeahagency/setCpsAffInfo`;
export const deleteCpsAffiliateInfoByOriAff = `${api}/Yeahagency/deleteCpsAffiliateInfoByOriAff`;
export const reportForCps = `${api}/Yeahagency/reportForCps`;

// export const dashboardForCps = `${api}/Yeahagency/dashboardForCps`;
export const dashboardForCps ='/waiterapi/Yeahagency/cps/dashboard'


// export const getTopAffiliateForCps = `${api}/Yeahagency/getTopAffiliateForCps`;
export const getTopAffiliateForCps = `/waiterapi/Yeahagency/cps/getTopAffiliateForCps`;

// export const getTopCampaignForCps = `${api}/Yeahagency/getTopCampaignForCps`;
export const getTopCampaignForCps = `/waiterapi/Yeahagency/cps/getTopCampaignForCps`;

export const getCpsAffiliateInfoByOriAff = `${api}/Yeahagency/getCpsAffiliateInfoByOriAff`;

// CPS模块_Creative
export const getCpsCreativeList = `${api}/Yeahagency/getCpsCreativeList`;


export const getPassportInfo = `/waiterapi/mgr/passport/get`;
// login api
export const login = `/waiterapi/Yeahagency/login`;

// export const getPassportInfo = `${api}/Session/getPassport`;
export const newGetpassInfo="/waiterapi/mgr/passport/get"
// logout api
// export const logout = `${api}/Session/logout`;
export const logout = `/waiterapi/Yeahagency/logout`;
// change password
export const changePassword = `${api}/Session/changePassword`;

// localMedia api
// setting
// export const getLocalmediaSettingList = `${api}/Yeahagency/getLocalmediaSettingList`;
export const getLocalmediaSettingList = `/waiterapi/Yeahagency/getLocalmediaSettingList`;
export const deleteLocalmediaAdvInfo = `${api}/Yeahagency/deleteLocalmediaAdvInfo`;
export const getLocalmediaSettingById = `${api}/Yeahagency/getLocalmediaSettingById`;
// export const getTimezoneList = `${api}/Yeahagency/getTimezoneList`;
export const getTimezoneList = `/waiterapi/Yeahagency/getTimezoneList`;
// export const getLocalmediaAgencyList = `${api}/Yeahagency/getLocalmediaAgencyList`;
export const getLocalmediaAgencyList = `/waiterapi/Yeahagency/getLocalmediaAgencyList`;
export const insertLocalmediaAdvInfo = `${api}/Yeahagency/insertLocalmediaAdvInfo`;
export const updateLocalmediaAdvInfo = `${api}/Yeahagency/updateLocalmediaAdvInfo`;
export const getPkgList = `${api}/Yeahagency/getPkgList`;
// setting Anayltics
export const uploadLocalmediaAnalysis = `${api}/Yeahagency/uploadLocalmediaAnalysis`;
// export const deleteOrLaunchLocalmediaAnalysis = `${api}/Yeahagency/deleteOrLaunchLocalmediaAnalysis`;
export const deleteOrLaunchLocalmediaAnalysis ='/waiterapi/Yeahagency/local/deleteOrLaunchLocalmediaAnalysis';
export const setLocalmediaAnalysisData = `${api}/Yeahagency/setLocalmediaAnalysisData`;
    // setting creatives
// export const getlocalmediaCreativeList = `${api}/Yeahagency/getlocalmediaCreativeList`;
export const getlocalmediaCreativeList = `/waiterapi/Yeahagency/getlocalmediaCreativeList`;
export const uploadlocalmediaCreative = `${api}/Yeahagency/uploadlocalmediaCreative`;
export const deleteorlaunchlocalmediaCreative = `${api}/Yeahagency/deleteorlaunchlocalmediaCreative`;
// export const getLocalMediaProductList = `${api}/Yeahagency/getLocalMediaProductList`;
export const getLocalMediaProductList = `/waiterapi/Yeahagency/getLocalMediaProductList`;
export const setlocalmediaCreative = `${api}/Yeahagency/setlocalmediaCreative`;
export const batchUpdatelocalmediaCreative = `${api}/Yeahagency/batchUpdatelocalmediaCreative`;
export const findByAdvId = `/waiterapi/Yeahagency/cust/app/findByAdvId`;

// report
export const checkLocalmediaAdv = `/waiterapi/Yeahagency/checkLocalmediaAdv`;
// report
export const reportForLocalmedia = `${api}/Yeahagency/reportForLocalmedia`;
// export const searchLocalmediaPkg = `${api}/Yeahagency/SearchLocalmediaPkg`;
export const searchLocalmediaPkg = `/waiterapi/Yeahagency/SearchLocalmediaPkg`;
export const searchLocalmediaMedia = `${api}/Yeahagency/SearchLocalmediaMedia`;
// export const searchlocalmediaAdv = `${api}/Yeahagency/SearchlocalmediaAdv`;   
export const searchlocalmediaAdv = `/waiterapi/Yeahagency/SearchlocalmediaAdv`;   
// dashboard

// export const dashboard = `${api}/Yeahagency/dashboard`
// export const getMediaTrends = `${api}/Yeahagency/getMediaTrends`
// export const getTopProducts = `${api}/Yeahagency/getTopProducts`
// export const getLocalMediaTopApp = `${api}/Yeahagency/topApp`;
// export const getLocalMediaTopMedia = `/waiterapi/Yeahagency/topMedia`;
// export const dashboardForLocalmedia = `${api}/Yeahagency/dashboardForLocalmedia`;
// export const dashboardDetailForLocalmedia = `${api}/Yeahagency/dashboardDetailForLocalmedia`;
export const dashboard = `/waiterapi/Yeahagency/home/dashboard`
export const getMediaTrends = `/waiterapi/Yeahagency/home/getMediaTrends`
export const getTopProducts = `/waiterapi/Yeahagency/home/getTopProducts`
export const getLocalMediaTopApp = `/waiterapi/Yeahagency/localmkt/topApp`;
export const getLocalMediaTopMedia = `/waiterapi/Yeahagency/localmkt/topMedia`;
export const dashboardForLocalmedia = `/waiterapi/Yeahagency/localmkt/dashboardForLocalmedia`;
export const dashboardDetailForLocalmedia = `/waiterapi/Yeahagency/localmkt/dashboardDetailForLocalmedia`;

// Analysis
// export const getLocalmediaAnalysisList= `${api}/Yeahagency/getLocalmediaAnalysisList`;
export const getLocalmediaAnalysisList= `/waiterapi/Yeahagency/getLocalmediaAnalysisList`;
export const downloadFile = `${api}/actions/yeahagency/DownloadFile.php`;
export const newdownloadFile = `/waiterapi/Yeahagency/pdf/load`;
// User Authority Setting api
export const getAccountList = `/waiterapi/Yeahagency/role/getAccountList`;
export const findAdvertisers = `/waiterapi/Yeahagency/module/findAdvertisers`;
export const deleteAccount = `${api}/Yeahagency/deleteAccount`;
export const createAccount = `${api}/Yeahagency/createAccount`;
export const editAccount = `${api}/Yeahagency/editAccount`;
// export const getBusinessList = `${api}/Yeahagency/getBusinessList`;
export const getBusinessList = `/waiterapi/Yeahagency/role/getBusinessList`;

export const getAllowedPkgList = `${api}/Yeahagency/getAllowedPkgList`;
export const getAuthAdvList = `/waiterapi/Yeahagency/role/getAuthAdvList`;

//Media Source
export const getMediaCaseList = `${api}/Yeahagency/getMediaCaseList`;
export const getMediaCaseListnew = '/waiterapi/Yeahagency/media/getMediaCaseList';
export const setMediaCase = `${api}/Yeahagency/setMediaCase`;
export const setMediaCaseNew = '/waiterapi/Yeahagency/media/setMediaCase'
export const deleteOrLaunchMediaCase = `${api}/Yeahagency/deleteOrLaunchMediaCase`;
export const deleteOrLaunchMediaCaseNew  ='/waiterapi/Yeahagency/media/deleteOrLaunchMediaCase'


export const reportExcelForInfluencer = '/waiterapi/Yeahagency/kolmkt/reportExcelForInfluencer'
// KOL MKT
export const getCampaignAndInfluencerList = '/waiterapi/Yeahagency/influencer/getCampaignAndInfluencerList'
  // dashboard

// export const dashboardForInfluencer = `${api}/Yeahagency/dashboardForInfluencer`;
export const dashboardForInfluencer ='/waiterapi/Yeahagency/kolmkt/dashboardForInfluencer'
export const getTopCampaignForInfluencer = `${api}/Yeahagency/getTopCampaignForInfluencer`;
export const getTopCampaignForInfluencerDetail = `${api}/Yeahagency/getTopCampaignForInfluencerDetail`;

// report
export const reportForInfluencer = `${api}/Yeahagency/reportForInfluencer`;
export const reportForInfluencer2=`/waiterapi/Yeahagency/kolmkt/reportForInfluencer`

export const getInfluencerAdvList = `${api}/Yeahagency/getInfluencerAdvList`;
export const getAdvListByModule=`/waiterapi/Yeahagency/role/getAdvListByModule`

  // setting Basic Data
export const getInfluencerSettingList = `/waiterapi/Yeahagency/influencer/getInfluencerSettingList`;
export const listInfluencerSettingsWithMergeFields = `/waiterapi/Yeahagency/influencer/listInfluencerSettingsWithMergeFields`;
export const createInfluencerData = `/waiterapi/Yeahagency/influencer/createInfluencerData`;
export const editInfluencerData = `/waiterapi/Yeahagency/influencer/editInfluencerData`;
export const deleteInfluencerData = `/waiterapi/Yeahagency/influencer/deleteInfluencerData`;
export const getInfluencerSettingDetail = `/waiterapi/Yeahagency/influencer/getInfluencerSettingDetail`;
export const getInfluencerSettingDetailById = `/waiterapi/Yeahagency/influencer/getInfluencerSettingDetailById`;
export const publishInfluencerReports= '/waiterapi/Yeahagency/influencer/publishInfluencerReports'
export const getInfluencerPlatformList = `/waiterapi/Yeahagency/influencer/getInfluencerPlatformList`;
export const publishInfluencerReport = `/waiterapi/Yeahagency/influencer/publishInfluencerReport`;
export const getInfluencerSettingDetailByIds = `/waiterapi/Yeahagency/influencer/getInfluencerSettingDetailByIds`;

  // setting Closing Report
export const listClosingReport = `/waiterapi/Yeahagency/influencer/listClosingReport`;
export const updateClosingReport = `/waiterapi/Yeahagency/influencer/updateClosingReport`;
export const uploadClosingReport = `/waiterapi/Yeahagency/influencer/uploadClosingReport`;
export const launchClosingReport = `/waiterapi/Yeahagency/influencer/launchClosingReport`;
export const deleteClosingReport = `/waiterapi/Yeahagency/influencer/deleteClosingReport`;
export const getCampaign = `/waiterapi/Yeahagency/influencer/getCampaign`;
export const getInfluencer = `/waiterapi/Yeahagency/influencer/getInfluencer`;

// search kot

// export const batchBulk=`/waiterapi/Kol/batchBulk`
export const batchBulk=`/waiterapi/Kol/batchBulk`
 export const createMultiResource='/waiterapi/Yeahagency/createMultiResource'
// resources
export const resourceList = `/waiterapi/Yeahagency/resourceList`;
export const updateResource = `/waiterapi/Yeahagency/updateResource`;
export const uploadResource = `/waiterapi/Yeahagency/uploadResource`;
export const deleteResource = `/waiterapi/Yeahagency/deleteResource`;
export const launchResource = `/waiterapi/Yeahagency/launchResource`;

export const downloadsReport = `${api}/Report/downloadsReport`;
export const searchPkgName = `${api}/Offer2/searchPkgName`;
export const youtobeSearch=`/waiterapi/Yeahagency/kol/search`
export const updateById=`/waiterapi/api/kol/updateById`;
export const mohuSearch=`/waiterapi/Yeahagency/kol/fuzzyQuery`;
export const priceSearch=`/waiterapi/Yeahagency/kolBasic/search`;
// public setting whatsnew
export const uploadNews = `/waiterapi/Yeahagency/uploadNews`;
export const updateNews = `/waiterapi/Yeahagency/updateNews`;
export const newsList = `/waiterapi/Yeahagency/newsList`;
export const deleteNews = `/waiterapi/Yeahagency/deleteNews`;
export const launchNews = `/waiterapi/Yeahagency/launchNews`;
export const homeNews = `/waiterapi/Yeahagency/homeNews`;
export const homeWall = `/waiterapi/Yeahagency/homeWall`;

// account

export const findAllAdvertiser=`/waiterapi/Yeahagency/account/findAllAdvertiser`

export const findAdvertiserModuleAndTeam=`/waiterapi/Yeahagency/account/findAdvertiserModuleAndTeam`

export const insertAdvertiserInfo=`/waiterapi/Yeahagency/account/insertAdvertiserInfo`


export const insertAdvertiserTeam=`/waiterapi/Yeahagency/account/insertAdvertiserTeam`


export const uploadImage=`/waiterapi/Yeahagency/account/uploadImage`


export const deleteAdvertiserTeam=`/waiterapi/Yeahagency/account/deleteAdvertiserTeam`

export const findTeamStructure=`/waiterapi/Yeahagency/account/findTeamStructure`
export const getManager = `${api}/Employee/getManager`

//helpcenter
export const uploadHelp=`/waiterapi/Yeahagency/uploadHelp`
export const findList=`/waiterapi/Yeahagency/help/findList`
export const updateHelp=`/waiterapi/Yeahagency/updateHelp`
export const deleteHelp=`/waiterapi/Yeahagency/deleteHelp`
export const faqHelp=`/waiterapi/Yeahagency/faqHelp`
export const fastHelp=`/waiterapi/Yeahagency/fastHelp`
export const launchHelp=`/waiterapi/Yeahagency/launchHelp`
export const fuzzyQuery=`/waiterapi/help/fuzzyQuery`

export const feedback=`/waiterapi/Yeahagency/feedback`
export const findByType=`/waiterapi/Yeahagency/help/findByType`
export const checkFaq=`/waiterapi/Yeahagency/help/checkFaq`
export const feedbackList=`/waiterapi/Yeahagency/feedbackList`
export const handleFeedback=`/waiterapi/Yeahagency/handleFeedback`
// notifications
export const queryUnreadCount = `/waiterapi/Yeahagency/notification/queryUnreadCount`;
export const updateMessage = `/waiterapi/Yeahagency/notification/updateMessage`;
export const getNotificationList = `/waiterapi/Yeahagency/notification/getNotificationList`;


// account authority
export const findModule = `/waiterapi/Yeahagency/module/findModule`;

export const insert='/waiterapi/Yeahagency/module/insert'
export const update='/waiterapi/Yeahagency/module/update'
export const deletes='/waiterapi/Yeahagency/module/delete'

export const findUsers='/waiterapi/Yeahagency/user/findUsers'

export const findManagers='/waiterapi/Yeahagency/user/findManagers'
export const insertOrUpdate='/waiterapi/Yeahagency/user/insertOrUpdate'

export const findAdvByUserId=  `/waiterapi/Yeahagency/user/findAdvByUserId`
export const findUserDeletes=  `/waiterapi/Yeahagency/user/delete`
export const findSettings=  `/waiterapi/Yeahagency/user/findSettings`

export const syncAppPicture=  `/waiterapi/Yeahagency/setting/syncAppPicture`
export const checkNumber=  `/waiterapi/Yeahagency/role/checkNumber`
export const accountuploadImage=  `/waiterapi/Yeahagency/account/uploadImage`

export const findAdvertiserLogo=  `/waiterapi/api/advertiser/findLogo`

export const positionShift =`/waiterapi/Yeahagency/media/positionShift`

export const exportLocalCreative =`/waiterapi/Yeahagency/local/exportLocalCreative`
export const visibleControl =`/waiterapi/Yeahagency/local/visibleControl`
export const findVisible =`/waiterapi/Yeahagency/local/findFeild`

export const getAdvLocalmediaCreative = `/waiterapi/Yeahagency/local/getAdvLocalmediaCreative`;


export const getSiteid = `/waiterapi/Yeahagency/local/getCampaign`;

export const insertAuthority= '/waiterapi/Yeahagency/role/insertAuthority';
export const findAuthority= '/waiterapi/Yeahagency/role/findAuthority';
export const AuthorityChange= '/waiterapi/Yeahagency/role/authorityChange';

export const getReservePrice= '/waiterapi/Yeahagency/media/getReservePrice';
export const uploadImageresource= '/waiterapi/Yeahagency/account/uploadImage';
export const downloadReport= '/waiterapi/Yeahagency/downloadReport';
export const findKpiRule= '/waiterapi/Yeahagency/localmkt/findKpiRule';

export const updateStatus='/waiterapi/Yeahagency/localmkt/updateStatus'
export const notificationSetting='/waiterapi/Yeahagency/notification/notificationSetting';
export const updateAllMessage='/waiterapi/Yeahagency/notification/updateAllMessage';
export const notificationSubList='/waiterapi/Yeahagency/notification/notificationSubList';
export const invoiceDetail='/waiterapi/Yeahagency/notification/invoiceDetail';
export const manuallyAsyncInvoice='/waiterapi/Yeahagency/notification/manuallyAsyncInvoice';
export const popUp='/waiterapi/Yeahagency/notification/popUp'

export const editKpi= '/waiterapi/Yeahagency/localmkt/editKpi';

export const reportForLocalmedia2='/waiterapi/Yeahagency/localmkt/reportForLocalmedia';
export const koldownload='/waiterapi/Yeahagency/kol/export'

export const koltempDown='/waiterapi/Yeahagency/kolEntryInfo/setting'
export const koltempcheckList='/waiterapi/Yeahagency/kolEntryInfo/list'
export const koltempDateUpdate='/waiterapi/Yeahagency/kolEntryInfo/saveOrUpdate'
export const koltempDatepublish='/waiterapi/Yeahagency/kolEntryInfo/publish'

export const koltempcheckListDelete='/waiterapi/Yeahagency/kolEntryInfo/delete'
export const koltempUpload='/waiterapi/Yeahagency/kolEntryInfo/upload'
export const mhSearch='/waiterapi/Yeahagency/kolEntryInfo/search/dropdownList'

export const mhSearchresult='/waiterapi/Yeahagency/kolEntryInfo/list'
export const findDate='/waiterapi/Yeahagency/influencer/findDate';
export const publishedInfo='/waiterapi/Yeahagency/kolEntryInfo/publishedInfo'
export const logintime='/waiterapi/Yeahagency/checkLoginInfo'
export const checkMediaSource='/waiterapi/Yeahagency/localmkt/checkMediaSource'
export const findCampaigns  ='/waiterapi/Yeahagency/localmkt/findCampaigns'
export const parsePdfAuth='/waiterapi/api/notification/parsePdfAuth'


export const getMediaSource='/waiterapi/Yeahagency/local/getMediaSource'
export const findBusinessByAdvId='/waiterapi/Yeahagency/account/findBusinessByAdvId'

// Programmatic MKT - manage // 程序化网盟接口
export const getProManageHeaderData='/waiterapi/Yeahagency/program/dashboardReport';
export const getProDashboardReportDetail='/waiterapi/Yeahagency/program/dashboardReportDetail';
export const getProManageTopBundleData='/waiterapi/Yeahagency/program/dashboardTopApp';
export const getProManageReportData='/waiterapi/Yeahagency/program/getAdvertiserReport';
export const getProManagePidPkg='/waiterapi/Yeahagency/program/findPidPkg';
export const getProManageSettingList='/waiterapi/Yeahagency/program/findFileList';
export const proManageDownloadTemplate='/waiterapi/Yeahagency/program/downloadTemplate';
export const proManageAddOrUpdatePidPkg='/waiterapi/Yeahagency/program/addOrUpdatePidPkg';
export const getproManageProgramAdv='/waiterapi/Yeahagency/program/findProgramAdv';
export const proManageUploadExcel='/waiterapi/Yeahagency/program/uploadFile';
export const getProManageAff='/waiterapi/Yeahagency/program/aff_ids';
export const saveProManageAff='/waiterapi/Yeahagency/program/aff_id/save';
export const deleteProManageAff='/waiterapi/Yeahagency/program/aff_id/delete';

export const getfolderList='/waiterapi/Yeahagency/kol_collection/name/list'
export const saveFolder='/waiterapi/Yeahagency/kol_collection/save'
export const deleteFolder='/waiterapi/Yeahagency/kol_collection/delete'
export const kolList='/waiterapi/Yeahagency/kol_collection/kol/list'

export const kolDetailList='/waiterapi/Yeahagency/kol_collection/detail'
export const kolListFolederList='/waiterapi/Yeahagency/kol_collection/list'

export const saveKoltoFolder='/waiterapi/Yeahagency/kol_collection_item/save'


export const deleteKoltoFolder='/waiterapi/Yeahagency/kol_collection_item/delete'


export const copyToFolder='/waiterapi/Yeahagency/kol_collection_item/copy'

export const moveToFolder='/waiterapi/Yeahagency/kol_collection_item/move'

export const ifLikeNot='/waiterapi/Yeahagency/kol_collection/kols/collect_status'
export const getPublishedInfoCost='/waiterapi/Yeahagency/kolEntryInfo/getPublishedInfoCost'
export const folderUpdate='/waiterapi/Yeahagency/kol_collection/update'

export const cancelToLike='/waiterapi/Yeahagency/kol_collection/kols/collect_status/cancel'

// kol tracking
export const productList='/waiterapi/Yeahagency/kol_manage/product_config/name/list'

export const addNewProcessUpload='/waiterapi/Yeahagency/kol_manage/file/upload'
export const addNewProcessSubmit='/waiterapi/Yeahagency/kol_manage/advertiser_order/submit'

export const overViewList='/waiterapi/Yeahagency/kol_manage/advertiser_order/list'

export const kolCurrentStepInfo='/waiterapi/Yeahagency/kol_manage/event/info'
export const findKolListByFolderLists='/waiterapi/Yeahagency/kol_collection/kol/infos'

export const submitCurrentStep='/waiterapi/Yeahagency/kol_manage/event/audit'

export const saveCurrentStep="/waiterapi/Yeahagency/kol_manage/event/save"
export const eventProcess="/waiterapi/Yeahagency/kol_manage/order/event/process"

export const productShowList="/waiterapi/Yeahagency/kol_manage/product_config/list"
export const productShowSave="/waiterapi/Yeahagency/kol_manage/product_config/save"
export const productShowUpdate="/waiterapi/Yeahagency/kol_manage/product_config/update"
export const productShowDelete="/waiterapi/Yeahagency/kol_manage/product_config/delete"
export const kolvalidate="/waiterapi/Yeahagency/kol_manage/confirm/kol/validate"
export const filterDropDownList="/waiterapi/Yeahagency/influencer/basicData/filterDropDownList"
export const getTopInfluencer="/waiterapi/Yeahagency/kol/getTopInfluencer"
export const getTopInfluencerDetail="/waiterapi/Yeahagency/kol/getTopInfluencerDetail"
export const getasyncUpload='/waiterapi/Yeahagency/kol_manage/product_config/file/asyncUpload'
export const getuoloadList='/waiterapi/Yeahagency/kol_manage/product_config/info'
export const fileDelete='/waiterapi/Yeahagency/kol_manage/product_config/file/delete'
export const dropdownList='/waiterapi/Yeahagency/kol_manage/video_review/file/dropdownList'

export const  pdfload='/waiterapi/Yeahagency/pdf/load'

export const  marketingList='/waiterapi/Yeahagency/kol_manage/marketing_config/list'
export const  marketingListSave='/waiterapi/Yeahagency/kol_manage/marketing_config/saveOrUpdate'
export const marketDelete='/waiterapi/Yeahagency/kol_manage/marketing_config/delete'
export const kolTrackCancel ='/waiterapi/Yeahagency/kol_manage/event/cancel'
export const uploadFile= '/waiterapi/Yeahagency/uploadFile'
export const findAllCurrency= '/waiterapi/Yeahagency/media/findAllCurrency'

// 梯煤api
export const getPibbCampaignQuery = '/waiterapi/Yeahagency/pi/bb/campaign/query'
export const getPibbCampaignDetail = '/waiterapi/Yeahagency/pi/bb/campaign/detail'
export const pibbCampaignCreate = '/waiterapi/Yeahagency/pi/bb/campaign/create'
export const getLogDetailData = '/waiterapi/Yeahagency/pi/bb/campaign/logDetail'
export const getApiSalesData = '/waiterapi/Yeahagency/pi/bb/campaign/apiSales'
export const getCitySalesData = '/waiterapi/Yeahagency/pi/bb/campaign/citySales'
export const getPointSales = '/waiterapi/Yeahagency/pi/bb/campaign/pointSales'
export const getParentCategory = '/waiterapi/Yeahagency/pi/bb/campaign/parentCategory'
export const getSubCategory = '/waiterapi/Yeahagency/pi/bb/campaign/subCategory'
export const getImpressionSales = '/waiterapi/Yeahagency/pi/bb/campaign/impressionSales'
export const getSettingProductPrice = '/waiterapi/Yeahagency/pi/bb/campaign/productPrice'
export const createLiftCampaign = '/waiterapi/Yeahagency/pi/bb/campaign/create'
export const settingCampaignUploadImg = '/waiterapi/Yeahagency/pi/bb/campaign/upload'
export const getPropertyInfo = '/waiterapi/Yeahagency/pi/bb/campaign/propertyInfo'
export const reportScreenShot = '/waiterapi/Yeahagency/pi/bb/campaign/screenshot'
export const getImpressionHome = '/waiterapi/Yeahagency/pi/bb/campaign/impressionHome'
export const getHomePropertys = '/waiterapi/Yeahagency/pi/bb/campaign/homePropertys'

export const findAMByAdvId= '/waiterapi/Yeahagency/user/findAMByAdvId'
export const updateNodeContext ='/waiterapi/Yeahagency/kol_manage/order/updateNodeContext' 
export const getAllPidList = `/waiterapi/Yeahagency/localmkt/findAllPid`;

export const basicIfoInsert='/waiterapi/Yeahagency/cust/save'
export const basicIfoUpdata='/waiterapi/Yeahagency/cust/saveItem'
export const basicIfoEdit='/waiterapi/Yeahagency/cust/edit'
export const basicIfoDelete='/waiterapi/Yeahagency/cust/enable'
export const basicIfoList='/waiterapi/Yeahagency/cust/query'
export const kunluncast='/waiterapi/Yeahagency/cust/kunluncust/query'

export const productSave='/waiterapi/Yeahagency/cust/product/save'
export const productUpdate='/waiterapi/Yeahagency/cust/product/saveItem'

export const productListfind='/waiterapi/Yeahagency/cust/product/query'
export const productDelete='/waiterapi/Yeahagency/cust/product/enable'
export const appcheckIfo='/waiterapi/Yeahagency/cust/app/info'

export const customList='/waiterapi/Yeahagency/cust/account/query'
export const customsave='/waiterapi/Yeahagency/cust/account/save'
export const customSaveItem='/waiterapi/Yeahagency/cust/account/saveItem'

export const customDelete='/waiterapi/Yeahagency/cust/account/enable'
export const saveKolDetail='/waiterapi/api/kol/batchBulk'
export const findId='/waiterapi/Yeahagency/kolBasic/findId' 


export const findAllRole='/waiterapi/Yeahagency/role/findAllRole'
export const findMenuRolePermission='/waiterapi/Yeahagency/role/findMenuRolePermission'
export const findMenuPermission='/waiterapi/Yeahagency/role/findMenuPermission'
export const addMenu='/waiterapi/Yeahagency/role/addMenu'
export const deleteMenuByCode='/waiterapi/Yeahagency/role/deleteMenuByCode'
export const updateMenuPermission='/waiterapi/Yeahagency/role/updateMenuPermission'
export const collectcancel='/waiterapi/Yeahagency/kol_collection/kols/collect_status/cancel'

export const savepwdFunc="/waiterapi/Yeahagency/cust/account/changePwd"
export const campaignAndInfluencerInfoList= `/waiterapi/Yeahagency/influencer/campaignAndInfluencerInfoList`
export const filterDropDownListclose= `/waiterapi/Yeahagency/influencer/closingReport/filterDropDownList`
export const carGet= `/waiterapi/Yeahagency/kol/campaign/cart/get`

export const saveCartItem = '/waiterapi/Yeahagency/kol/campaign/cart/saveCartItem'


export const deleteCartItem = '/waiterapi/Yeahagency/kol/campaign/cart/deleteCartItem'

export const cartItemSubmit = '/waiterapi/Yeahagency/kol/campaign/cart/cartItemSubmit'

export const writeAndReadAuthorty = "/waiterapi/Yeahagency/kol/campaign/doc/getSchema"
export const docGet = "/waiterapi/Yeahagency/kol/campaign/doc/get"
export const docSave = "/waiterapi/Yeahagency/kol/campaign/doc/saveDraft"
export const docSubmit ='/waiterapi/Yeahagency/kol/campaign/doc/submit'

export const docSaveProperty='/waiterapi/Yeahagency/kol/campaign/doc/saveProperty'

export const docMunu='/waiterapi/Yeahagency/docBook/contents'
export const docNode='/waiterapi/Yeahagency/docBook/node'
export const saveNodeInfo='/waiterapi/Yeahagency/docBook/node/save'
export const deleteNode='/waiterapi/Yeahagency/docBook/node/delete'

export const saveDraft='/waiterapi/Yeahagency/docBook/node/saveDraft'
export const  watierDownloadFile='/waiterapi/Yeahagency/DownloadFile'
export const cartOrder='/waiterapi/Yeahagency/kol/campaign/cart/adjustOrder'

export const advertiserCreate='/waiterapi/mgr/advertiser/create'

export const searchAdvertiserGroup = `${api}/Advertiser/searchAdvertiserGroup`
export const getByContractId =  '/waiterapi/mgr/advertiser/getByContractId'

export const ymAdvIdList='/waiterapi/Yeahagency/cust/account/advertiser'
export const searchByCustId='/waiterapi/Yeahagency/contract/searchByCustId'




// WEBPACK FOOTER //
// ./src/util/request/api.js